import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import auth from './auth';
import users from './users';
import entries from './entries';
import horses from './horses';
import vaulters from './vaulters';
import lungers from './lungers';
import additionalHorses from './additionalHorses';
import nations from './nations';
import nationHorses from './nationHorses';
import feiId from './feiId';
import loader from './loader';

const appReducer = combineReducers({
  auth,
  users,
  entries,
  horses,
  vaulters,
  lungers,
  additionalHorses,
  nationHorses,
  nations,
  feiId,
  loader,
  routing: routerReducer,
  toastr: toastrReducer,
});

export default (state, action) => {
  if (action.type === 'LOGOUT_USER') {
    state = undefined;
  }

  return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js